import DashboardLayout from '../../../../commons/DashboardLayout/DashboardLayout';
import moment from 'moment';
import Chip from '../../../../designSystem/Chip/Chip';
import { getChipContentByStepId } from '../../../../../utils/helpers/consultation/getChipContentByStepId';
import { useNavigate } from 'react-router-dom';
import { useCompanyInProgressConsultations } from '../../../../../hooks/fetchers/useCompanyInProgressConsultations/useCompanyInProgressConsultations';
import { useState } from 'react';
import Loading from '../../../../commons/Loading/Loading';

export default () => {
  const [currentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(25);

  const { data, isLoading } = useCompanyInProgressConsultations({
    page: currentPage,
    perPage: itemsPerPage,
  });

  const navigate = useNavigate();

  return (
    <DashboardLayout>
      {isLoading ? (
        <Loading />
      ) : (
        <table className="dashboard__table dashboard-invoices__table">
          <colgroup>
            <col style={{ width: '60%' }} />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th>Titre</th>
              <th>Début</th>
              <th>Fin</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data ? (
              data.results.map((consultation, index) => {
                const { id, title, start, end } = consultation;
                const { label, color } = getChipContentByStepId(consultation);
                return (
                  <tr
                    key={index}
                    className="dashboard-commerciaux__table-tr--clickable"
                    style={label === 'Clôturée' ? {
                      display: 'none'
                    } : undefined}
                    onClick={() => navigate(`/dashboard/historique/${id}`)}>
                    <td>{title}</td>
                    <td>{moment(start).format('DD-MM-YYYY')}</td>
                    <td>{moment(end).format('DD-MM-YYYY')}</td>
                    <td>
                      <Chip {...{ color }}>{label}</Chip>
                    </td>
                    {/* <td>{id_step}</td> */}
                  </tr>
                );
              })
            ) : (
              <div style={{ position: 'absolute', width: '100%' }}>
                <h1
                  style={{
                    color: 'var(--gray-4)',
                    fontFamily: 'Quicksand-Medium',
                    fontWeight: 400,
                  }}>
                  Vous n'avez aucune consultation en cours
                </h1>
              </div>
            )}
          </tbody>
        </table>
      )}
    </DashboardLayout>
  );
};
